import cn from 'classnames';
import { AddIcon } from '#assets/ReactSvg.ts';
import { InlineButton } from '#components/atoms/buttons/inline-button/InlineButton.tsx';
import styles from './AddButton.module.css';

type Props = React.ComponentPropsWithRef<'button'>;

export function AddButton({ className, children = 'Add', ...props }: Props) {
  return (
    <InlineButton {...props} className={cn(className, styles.AddButton)}>
      <span aria-hidden>
        <AddIcon height={12} width={12} />
      </span>
      {children}
    </InlineButton>
  );
}
